import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface VerifyIssuesState {
  verifyissue: {
    load: boolean;
    data: [];
  };
}

export const IssueSlice = createSlice({
  name: "verifyissue",
  initialState: {
    verifyissue: {
      load: false,
      data: [],
    },
  } as VerifyIssuesState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchTpiReportedIssuesListToVerify.pending, (state: VerifyIssuesState) => {
        state.verifyissue.load = true;
      })
      .addCase(fetchTpiReportedIssuesListToVerify.fulfilled, (state: VerifyIssuesState, action: any) => {
        state.verifyissue.data = action.payload;
        state.verifyissue.load = false;
      })
      .addCase(fetchTpiReportedIssuesListToVerify.rejected, (state: VerifyIssuesState) => {
        state.verifyissue.load = false;
      });
  },
});

export default IssueSlice.reducer;

export const fetchTpiReportedIssuesListToVerify = createAsyncThunk(
  "verifyissue/fetchTpiReportedIssuesList",
  async (param: {apiParam: {project_pin: any, layout_id: any, verification_type: any}}, thunkAPI) => {
    try {
      const { data } = await DataServer.post(`api/getIssueWiseCountForAutoVerification`, {
        project_pin: param.apiParam.project_pin,
        layout_id: param.apiParam.layout_id,
        verification_type: param.apiParam.verification_type
      });
      return data.data;
    } catch (error) {
    }
  }
);
